import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectorRef } from "@angular/core";
import { SharedService } from '../shared';
import { IQuestionnaireResponseData } from '../dateneingabe-frageboge/questionnaire.model';


@Component({
    selector: 'app-datenebank-shared-case-en',
    templateUrl: "./shared-case-en.component.html",
    styleUrls: ["./shared-case-en.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class DatenebankSharedCaseENComponent implements OnInit {
    @Input() uniqueId: any = "";
    showLoader: boolean = false;
    cardDetail: IQuestionnaireResponseData;

    constructor(private cd: ChangeDetectorRef,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {
        const queries = this.sharedService.getUrlVars();
        const dc = queries["dc"];
        const dc_timestamp = queries["dc_timestamp"];
        if (dc && dc_timestamp) {
            this.cd.detectChanges();
            this.fnGetDatenebankDetail();
        } else {
            window.open(`/pep/en/case/doccheck/${this.uniqueId}`, "_self");
        }
    }

    fnGetDatenebankDetail() {
        this.showLoader = true;
        this.sharedService.getDatenebankENByUniqueId(this.uniqueId).subscribe({
            next: (res) => {
                this.cardDetail = res;
                this.showLoader = false;
            },
            error: (err) => {
                this.showLoader = false;
            }
        })
    }
}
